export default {
	name: 'homePage',
	title: 'Home Page',
	type: 'document',
	fields: [
		{
			name: 'title',
			title: 'Page Title',
			type: 'string',
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'hero',
			title: 'Hero Section',
			type: 'heroSection',
		},
		{
			name: 'usp',
			title: 'Value Proposition Section',
			type: 'uspSection',
		},
		{
			name: 'services',
			title: 'Services Section',
			type: 'servicesSection',
		},
		{
			name: 'video',
			title: 'Video Section',
			type: 'videoSection',
		},
		{
			name: 'topSellers',
			title: 'Top Sellers Section',
			type: 'topSellersSection',
		},
		{
			name: 'workshops',
			title: 'Workshops Section',
			type: 'workshopsSection',
		},
		{
			name: 'testimonials',
			title: 'Testimonials Section',
			type: 'testimonialsSection',
		},
		{
			name: 'partners',
			title: 'Partners Section',
			type: 'partnersSection',
		},
		{
			name: 'stats',
			title: 'Stats Section',
			type: 'statsSection',
		},
		{
			name: 'faq',
			title: 'FAQ Section',
			type: 'faqSection',
		},
	],
	preview: {
		select: {
			title: 'title',
		},
	},
};
